module.exports = __webpack_public_path__ + "img/welcome_3.ed6a9f4a.jpg";